import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";


import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import AOS from "aos";
import "aos/dist/aos.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Calendar } from "primereact/calendar";
import { useDictionary } from "../../contexts/dictionary";
import styled from "styled-components";

import {HeroBanner, VImage } from "../../style/base.style";

import { choose01, client03, client04, doctor_01, doctor_02, doctor_03, doctor_04, doctor_05, service_01, service_02, service_03, service_04, service_05, service_06, service_07, specialities_01, specialities_02, specialities_03, specialities_04, specialities_05, specialities_06 
  ,banner_img, blog_11, blog_12, blog_20, blog_23, client01, faq_img, header_icon, partners_1, partners_2, partners_3, partners_4, partners_5, partners_6, smiling_icon, work_01, work_02, work_03, work_04, work_img,
  service_10,
  clalit,
  meuhedet,
  macabi,
  leumit,
  service_11,
  contract_01,
  contract_02,
  contract_03,
  doctorBanner4,
  faq_img2,
  bannerBackground,
  hexagenBg,
  footerBg1,
  footerBg2,
  footerBg3,
  footerBg4,
  footerBg5,
  handMoney,
  circDouble
} from "../../constants/images";
import PricingPlan from "../../components/pricing plan";
import { ArticlesSection } from "../../components/articlesSection";
import { FAQComponent } from "../../components/faq";
import { testimonialsData } from "../../assets/constant/testimonials";
import { Colors } from "../../style/colors";
import { useDeviceType } from "../../contexts/DeviceContext";
import { Hero } from "../../components/common/hero";
import { routesMap } from "../../constants/routes";
import { useContactType } from "../../contexts/ContactContext";


const BenefitContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-self: flex-end;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  gap: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 225px;
  margin-top: 10px;
`;

const DoctorsMainContainer = styled.div`
  display: flex;
  flex-direction:  column;
  align-items: flex-start;
  /* justify-self: flex-end; */
  background-color: white;
  padding: 10px;
  padding-left: 35px;
  border-radius: 5px;
  gap: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 245px;
  margin-top: 10px;
`;

const Checkbox = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 10px;
  background-color: ${Colors.primary};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    content: "✔";
    color: white;
    font-size: 12px;
  }
`;

const BenefitTitle = styled.span`
  font-size: 16px;
  color: #333;
`;

const DoctorContainer = styled.div`
display: flex;

margin-top: 10px;
`;

const DoctorImage = styled.img`
width: 75px;
height: 75px;
border-radius: 50%;
object-fit: cover;
margin-left: -25px;
`;

const Benefits = ({ titles }: { titles: string[] }): React.ReactElement => {
  const { translate } = useDictionary();

  return (
    <React.Fragment>
      {titles.map((title, index) => (
        <BenefitContainer key={index}>
          <Checkbox />
          <BenefitTitle>{translate(title)}</BenefitTitle>
        </BenefitContainer>
      ))}
    </React.Fragment>
  );
};




const Home1 = () => {
 
  const {translate} = useDictionary();

 
const {contact} = useContactType()

  const benefits = [
    'benefit1',
    'benefit2',
    'benefit3',
    'benefit4',
  ]

  const services :Service[] = [
    { color: "blue-bg", img: service_10, title: translate("consultation") },
    { color: "green-bg", img: service_02, title: translate("diagnostic_tests") },
    { color: "info-bg", img: service_11, title: translate("pregnancy_basket") },
    { color: "red-bg", img: service_04, title: translate("pain_clinic") },
    { color: "success-bg", img: service_05, title: translate("physiotherapy") },
    { color: "pink-bg", img: service_06, title: translate("online_doctor") },
    { color: "danger-bg", img: service_07, title: translate("doctor_to_the_house") },
  ];
  


  const specialities:Specialitie[] = [
    {
      name: translate("speciality_cardiology"),
      img:specialities_01,
    },
    {
      name: translate("speciality_neurology"),
      img:specialities_02,
    },
    {
      name: translate("speciality_urology"),
      img:specialities_03,
    },
    {
      name: translate("speciality_orthopedic"),
      img:specialities_04
    },
    {
      name: translate("speciality_dentist"),
      img:specialities_05
    },
    {
      name:translate("speciality_ophthalmology"),
      img:specialities_06,
    },
   
  ]

  const doctors:Doctor[] = [
    {
      id: 1,
      name: translate("dr_downer"),
      img: doctor_01,
      speciality: translate("speciality_orthopedic"),
      rating: 4.5,
      reviews: 35,
    },
    {
      id: 3,
      name: translate("dr_aviles"),
      img: doctor_03,
      speciality: translate("speciality_neurology"),
      rating: 4.0,
      reviews: 20,

    },
    {
      id: 4,
      name: translate("dr_palmore"),
      img: doctor_04,
      speciality: translate("speciality_immunologist"),
      rating: 4.5,
      reviews: 35,


    },
    {
      id: 5,
      name: translate("dr_paul_richard"),
      img: doctor_05,
      speciality: translate("speciality_dentist"),
      rating: 4.4,
      reviews: 50,

    },
  ];

  const contractServices:Doctor[] = [
    {
      id: 1,
      name: translate("service_title_mushlam_briut"),
      img: contract_01,
      speciality: translate("service_desc_mushlam_briut"),
      rating: 4.5,
      reviews: 35,
    },
    {
      id: 2,
      name: translate("service_title_mushlam_plus"),
      img: contract_02,
      speciality: translate("service_desc_mushlam_plus"),
      rating: 4.0,
      reviews: 20,

    },
    {
      id: 3,
      name: translate("service_title_mushlam_at_home"),
      img: contract_03,
      speciality: translate("service_desc_mushlam_at_home"),
      rating: 4.5,
      reviews: 35,


    },

  ];
  
  const [date1, setDate1] = useState(null);
  const {isMobile} = useDeviceType()
  AOS.init();
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  const handleScroll = () => {
    AOS.refresh();
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const CustomNextArrow = ({ className, onClick }:{ className?:string, onClick?:()=>void }) => (
    <div className="owl-nav slide-nav-1 text-start nav-control">
      <button type="button" role="presentation" className="owl-next" onClick={onClick}>
        <i className="fas fa-chevron-right custom-arrow" />
      </button>
    </div>
  );
  
  const CustomPrevArrow = ({ className, onClick }:{ className?:string, onClick?:()=>void }) => (
    <div className="owl-nav slide-nav-1 text-start nav-control">
      <button type="button" role="presentation" className="owl-prev" onClick={onClick}>
        <i className="fas fa-chevron-left custom-arrow" />
      </button>
    </div>
  );


  const bestDoctorsSlider = {
    slidesToShow: 3,
        slidesToScroll: 1,
        dots: isMobile,
        arrows: false,
        infinite: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 0,
                settings: {
                    vertical: true,
                    slidesToShow: 1,
                },
            },
        ],
  };
  const partnersSlider = {
    slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        autoplay:true,
        arrows: false,
        infinite: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 0,
                settings: {
                    vertical: false,
                    slidesToShow: 1,
                },
            },
        ],
  };
  const testimonialSlider = {
    dots: false,
    autoplay: false,
    infinite: true,
    speed: 2000,
    variableWidth: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  

  return (
    <div className="main-wrapper home-one">
      <Header />
      {/* Home Banner */}
      
    <Hero heroImg={doctorBanner4} height={75} backgroundImage={circDouble}  backgroundColor={Colors.lightBackground}>
    <div className="banner-content aos" data-aos="fade-up">
                <h1>
                <span>{translate('home_banner_t1')}</span> {translate('home_banner_t2')}
                </h1>
                <VImage
                  src={header_icon}
                  className="header-icon"
                  alt="header-icon"
                />
                <p>{translate('home_banner_st1')}</p>
                {
                  !contact && 
                  <Link to={routesMap.register.to} className="btn btn-primary">
                  {translate('register_now')}
                </Link>
                }
                 {
                  contact && 
                  <Link to={routesMap.dashboard.to} className="btn btn-primary">
                  {translate('go_to_dashboard')}
                </Link>
                }
          
              </div>
    </Hero>
  
      {/* /Home Banner */}
      {/* Specialities Section */}
      
      <section className="specialities-section-one">
        <div className="container">
        <div className="row">
            <div className="col-md-6 col-7 aos" data-aos="fade-up">
              <div className="section-header-one section-header-slider">
                <h2 className="section-title">{translate('specialities')}</h2>
              </div>
            </div>
            <div className="col-md-6 col-5  aos" data-aos="fade-up">
              <div className="owl-nav slide-nav-1 text-end nav-control" />
            </div>
          </div>
          <div className="service-sec-one">
            <div className="row row-cols-7 row-cols-xxl-7 row-cols-xl-4 row-cols-lg-4 rows-cols-md-6 justify-content-center">
              {
                services.map((service, index) => (
                  <div className="col-12 d-flex col-xxl col-lg-3 col-sm-6" key={index}>
                <Link to="#" className={`serv-wrap ${service.color} flex-fill`}>
                  <span>
                    <VImage
                      src={service.img}
                      alt="heart-image"
                      className="img-fluid"
                    />
                  </span>
                  <h4>{service.title}</h4>
                </Link>
              </div>
                ))
              }
              
            </div>
          </div>
          
          {/* <div
            className="specialities-slider-one owl-theme aos slick-arrow-right"
            data-aos="fade-up"
          >
            <Slider {...specialitiesSlider}>
            { specialities && 
              specialities.map((speciality, index) => (
                <div className="item" key={index}>
                  <div className="specialities-item">
                    <div className="specialities-img">
                      <span>
                        <VImage
                          src={speciality.img}
                          
                        />
                      </span>
                    </div>
                    <p>{translate(speciality.name)}</p>
                  </div>
                </div>  
              ))
            }
          
            </Slider>
          </div> */}
          
        </div>
      </section>
      {/* /Specialities Section */}
      {/* Doctors Section */}
      <section className="doctors-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 aos" data-aos="fade-up">
              <div className="section-header-one section-header-slider text-center">
                <h2 className="section-title">{translate('our_contract_services')}</h2>
              </div>
            </div>
          </div>
          <div className="doctor-slider-one owl-theme aos" data-aos="fade-up">
            <Slider {...bestDoctorsSlider}>
         
              {
              contractServices &&
              contractServices.map((doctor, index) => (
                 <div className="item" key={index}>
                 <div className="doctor-profile-widget doc-item">
                   <div className="doc-pro-img">
                     <Link to={`/services/${doctor.id}`}>
                       <div className="doctor-profile-img">
                        <VImage height={410} width={410}  src={doctor.img} className="img-fluid" />
                       </div>
                     </Link>
                 
                   </div>
                   <div className="doc-content">
                     <div className="doc-pro-info">
                       <div className="doc-pro-name">
                         <Link to={`/services/${doctor.id}`}>{doctor.name}</Link>
                         <p>{doctor.speciality}</p>
                       </div>
                       <div className="reviews-ratings">
                         <p>
                           <span>
                             <i className="fas fa-star" /> {doctor.rating}
                           </span>{" "}
                           ({doctor.reviews})
                         </p>
                       </div>
                     </div>
                  
                   </div>
                 </div>
               </div>
              ))
                }
             
           
            </Slider>
          </div>
        </div>
      </section>
      {/* /Doctors Section */}
      {/* Pricing */}
                <PricingPlan/>

      {/* /Pricing */}
      {/* How it Works Section */}
      <section className="work-section">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-12 work-img-info aos"
              data-aos="fade-up"
            >
              <div className="work-img">
                <VImage
                  src={work_img}
                  className="img-fluid"
                  alt="doctor-image"
                />
              </div>
            </div>
            <div className="col-lg-8 col-md-12 work-details">
              <div className="section-header-one aos" data-aos="fade-up">
                <h5>{translate('need_a_doctor')}</h5>
                <h2 className="section-title">
                  {translate('how_it_works_title')}
                </h2>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-6 aos" data-aos="fade-up">
                  <div className="work-info">
                    <div className="work-icon">
                      <span>
                        <VImage
                          src={work_01}
                          alt="search-doctor-icon"
                        />
                      </span>
                    </div>
                    <div className="work-content">
                      <h5>{translate('how_it_works_step1_title')}</h5>
                      <p>
                      {translate('how_it_works_step1_desc')}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 aos" data-aos="fade-up">
                  <div className="work-info">
                    <div className="work-icon">
                      <span>
                        <VImage
                          src={work_02}
                          alt="doctor-profile-icon"
                        />
                      </span>
                    </div>
                    <div className="work-content">
                    <h5>{translate('how_it_works_step2_title')}</h5>
                      <p>
                      {translate('how_it_works_step2_desc')}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 aos" data-aos="fade-up">
                  <div className="work-info">
                    <div className="work-icon">
                      <span>
                        <VImage
                          src={work_03}
                          alt="calendar-icon"
                        />
                      </span>
                    </div>
                    <div className="work-content">
                    <h5>{translate('how_it_works_step3_title')}</h5>
                      <p>
                      {translate('how_it_works_step3_desc')}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 aos" data-aos="fade-up">
                  <div className="work-info">
                    <div className="work-icon">
                      <span>
                        <VImage
                          src={handMoney}
                          alt="solution-icon"
                        />
                      </span>
                    </div>
                    <div className="work-content">
                    <h5>{translate('how_it_works_step4_title')}</h5>
                      <p>
                      {translate('how_it_works_step4_desc')}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Work Section */}
      {/* Articles Section */}
            <ArticlesSection/>
      {/* /Articles Section */}
      {/* App Section */}
   
      {/* /App Section */}
      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-header-one aos" data-aos="fade-up">
                <h5>{translate('get_answers')}</h5>
                <h2 className="section-title">{translate('faq_title')}</h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-12 aos" data-aos="fade-up">
              <div className="faq-img">
                <VImage
                $borderRadius="10px"
                  src={faq_img2}
                  $width={"500px"}
                  
                  className="img-fluid"
                  alt="img"
                />
                {/* <div className="faq-patients-count">
                  <div className="faq-smile-img">
                    <VImage
                      src={smiling_icon}
                      alt="icon"
                    />
                  </div>
                  <div className="faq-patients-content">
                    <h4>
                      <span className="count-digit">5</span>k+
                    </h4>
                    <p>{translate('happy_patients')}</p>
                  </div>
                </div> */}
              </div>
              
            </div>
            <div className="col-lg-7 col-md-12 aos" data-aos="fade-up">
            <FAQComponent numberOfQuestions={6}/>
            </div>
                
          </div>
        </div>
      </section>
      {/* /FAQ Section */}
      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="testimonial-slider slick">
              <div className="section-header-one section-header section-inner-header testimonial-header">
                          <h5>{translate('testimonials')}</h5>
                          <h2 className="section-title">
                            {translate('what_our_clients_say')}
                          </h2>
                        </div>
                <Slider {...testimonialSlider}>
                  {
                    testimonialsData.map((testimonial, index) => (
                      <div key={index}>
                        <div className="testimonial-grid" >
                    <div className="testimonial-info">
                    
                      <div className="testimonial-content">
                        
                        <div className="testimonial-details">
                          <p>
                           {translate(testimonial.content)}
                          </p>
                          <h6>
                            <span className="d-block">{translate(testimonial.name)}</span> 
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                      
                    ))
                  }
                
                 
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Testimonial Section */}
      {/* Partners Section */}
      <section className="partners-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="section-header-one text-center aos"
                data-aos="fade-up"
              >
                <h2 className="section-title">{translate('work_with')}</h2>
              </div>
            </div>
          </div>
          <div className="partners-info aos" data-aos="fade-up">
            <ul className="partners-slider slick-margins">
              <Slider {...partnersSlider}>
                <li>
                  <Link to="#">
                    <VImage
                      className="img-fluid"
                      src={clalit}
                      alt="partners"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <VImage
                      className="img-fluid"
                      src={meuhedet}
                      alt="partners"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <VImage
                      className="img-fluid"
                      src={macabi}
                      alt="partners"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <VImage
                      className="img-fluid"
                      src={leumit}
                      alt="partners"
                    />
                  </Link>
                </li>
               
              </Slider>
            </ul>
          </div>
        </div>
      </section>
      {/* /Partners Section */}
      <Footer />
    </div>
  );
};

export default Home1;
